'use strict';

import {mutate} from './promise-fastdom';
import CanvasOverlay from './CanvasOverlay';
import ObserverList from './ObserverList';
import imagePhysicalSize from './image-physical-size';

// const instances = new Map();

export default function CanvasImage(image, options) {
    this.image = image;
    this.overlay = new CanvasOverlay(this.image, options);
    this.canvas = this.overlay.canvas;
    this.overlay.addObserver((data) => this.update(data));
    this.ctx = this.overlay.canvas.getContext('2d');
    this.observers = new ObserverList();
}

CanvasImage.prototype.destroy = function () {
    this.overlay.destroy();
};

CanvasImage.prototype.addObserver = function (observer) {
    this.observers.add(observer);
};

CanvasImage.prototype.removeObserver = function (observer) {
    this.observers.remove(observer);
};

CanvasImage.prototype.notify = function (data) {
    this.observers.update(data);
};

CanvasImage.prototype.update = function (data) {
    imagePhysicalSize.call(this.image)
        .then(mutate(({naturalWidth, naturalHeight}) => {
            const width = data.realWidth;
            const height = data.realHeight;
            this.canvas.width = width;
            this.canvas.height = height;
            let ratio;

            // draw image inside canvas
            switch (data.fit) {
                case 'cover':
                    ratio = Math.max(width / naturalWidth, height / naturalHeight);
                    // console.log('cover', width, height, naturalWidth, naturalHeight, ratio);
                    this.ctx.drawImage(
                        this.image,
                        (naturalWidth - width / ratio) / 2, // sx
                        (naturalHeight - height / ratio) / 2, // sy
                        width / ratio, // swidth
                        height / ratio, // sHeight
                        0, // dx
                        0, // dy
                        width, // dWidth
                        height // dHeight
                    );
                    break;
                case 'contain':
                    ratio = Math.min(width / naturalWidth, height / naturalHeight);
                    // console.log('contain', width, height, naturalWidth, naturalHeight, ratio);
                    this.ctx.drawImage(
                        this.image,
                        0, // sx
                        0, // sy
                        naturalWidth, // sWidth
                        naturalHeight, // sHeight
                        (width - naturalWidth * ratio) / 2, // dx
                        (height - naturalHeight * ratio) / 2, // dy
                        naturalWidth * ratio, // dWidth
                        naturalHeight * ratio // dHeight
                    );
                    break;
                default:
                    // console.log('default', width, height, naturalWidth, naturalHeight);
                    this.ctx.drawImage(
                        this.image,
                        0,
                        0,
                        naturalWidth,
                        naturalHeight,
                        0,
                        0,
                        width,
                        height
                    );
                    break;
            }

            this.notify();
        }));
};

